import type { DetailedHTMLProps, StyleHTMLAttributes } from "react";
import { getTenantThemeStylesheet } from "./getTenantThemeStylesheet";

export interface TenantThemeStylesheetProps {
  tenantConfigId?: string | null;
  scoped?: boolean;
}

// `precedence` + `href` opt this tag into React's stylesheet Resource
// handling instead of ordinary position-based hydration matching, so
// third-party DOM mutation of <head> siblings (browser extensions, etc.)
// can't produce a hydration mismatch here. Not yet reflected in @types/react.
type StyleResourceProps = DetailedHTMLProps<StyleHTMLAttributes<HTMLStyleElement>, HTMLStyleElement> & {
  precedence?: string;
  href?: string;
};

export async function TenantThemeStylesheet({ tenantConfigId, scoped = true }: TenantThemeStylesheetProps) {
  const css = await getTenantThemeStylesheet(tenantConfigId, scoped);

  const styleProps: StyleResourceProps = {
    precedence: "default",
    href: `tenant-theme-${tenantConfigId ?? "none"}-${scoped ? "scoped" : "global"}`,
    suppressHydrationWarning: true,
    children: css,
  };

  return <style {...styleProps} />;
}
